import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import BetslipBaseModule from '../../base/betslip-base.module';
import BetslipDigitalBetPlacementModule from '../betplacement/betslip-digital-betplacement.module';
import TaxationInfoHelpTextComponent from '../taxation/components/digital/taxation-info-help-text.component';
import { BetslipTaxationLiabilityComponent } from './components/betslip-taxation-liability.component';
import TaxationInfoComponent from './components/digital/taxation-info.component';

@NgModule({
    imports: [CommonModule, BetslipBaseModule, BetslipDigitalBetPlacementModule, BetslipTaxationLiabilityComponent],
    declarations: [TaxationInfoComponent, TaxationInfoHelpTextComponent],
    exports: [BetslipTaxationLiabilityComponent, TaxationInfoComponent],
})
export default class BetslipDigitalTaxationModule {}
